/**
 * Types
 */
import type { TreeDataNode } from 'antd';

/**
 * 通过 Key 查找节点
 */
export const findNodeByKey = (nodes: TreeDataNode[], key: string): TreeDataNode | null => {
    for (const node of nodes) {
        if (node.key === key) return node;

        if (node.children) {
            return findNodeByKey(node.children, key);
        }
    }

    return null;
};

/**
 * 通过 Key 查找父级节点
 */
export const findParentNodeByKey = (nodes: TreeDataNode[], key: string): TreeDataNode | null => {
    for (const node of nodes) {
        if (node.children) {
            for (const child of node.children) {
                if (child.key === key) return node;
            }

            const parent = findParentNodeByKey(node.children, key);

            if (parent) return parent;
        }
    }

    return null;
};
